export default {
  // Header Section
  "discover_your": "உங்கள்",
  "nature_report": "நடத்தை/குணநிலை பகுப்பாய்வு",
  "natural_personality_insights": "இயற்கை தன்மை நுண்ணறிவுகள்",
  "nature_report_description": "முழுமையான பகுப்பாய்வின் மூலம் உங்கள் இயல்பான தன்மையையும் உட்புற குணநலன்களையும் புரிந்து கொள்ளுங்கள். பிறப்பு விவரங்களின் அடிப்படையில் உங்கள் இயற்கை நடத்தை முறைபாடுகள், உட்கார்ந்த வலிமைகள், மைய மனோபாவம் மற்றும் உண்மையான வெளிப்பாட்டு பாணியை அறிய உதவும்.",

  // Service Information
  "enter_details_for_nature_analysis": "குணநிலை பகுப்பாய்விற்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_nature_analysis": "முழுமையான குணநிலை பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_nature_analysis_note": "உங்கள் இயற்கை தன்மை மற்றும் நடத்தை முறைபாடுகளின் ஆழமான பகுப்பாய்வு",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_natural_vibration": "உங்கள் பெயர், உங்கள் இயற்கை தன்மையின் அதிர்வுகளுடன் ஒலிக்கிறது",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_personality_nature": "உங்கள் இயற்கையான தன்மை பண்புகள் மற்றும் மூலக்கூறு இயல்பை நிர்ணயிக்க இவை அவசியம்",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் குணநிலை பகுப்பாய்வு தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Nature Features
  "personality_traits_analysis": "தன்மை பண்புகள் பகுப்பாய்வு",
  "behavioral_patterns_insights": "நடத்தை முறைபாடுகள் நுண்ணறிவுகள்",
  "strengths_weaknesses_profile": "வலிமைகள் & பலவீனங்கள் சுயவரைபடம்",
  "natural_talents_discovery": "இயல்பான திறமைகள் கண்டுபிடிப்பு",
  "life_approach_guidance": "வாழ்க்கை அணுகுமுறை வழிகாட்டுதல்",
  "pdf_download": "முழுமையான PDF அறிக்கை",

  "what_you_get": "உங்கள் குணநிலை பகுப்பாய்வில் உள்ளவை",
  "comprehensive_personality_profile": "முழுமையான தன்மை சுயவிவரம்",
  "natural_behavior_patterns": "இயற்கை நடத்தை முறைபாடுகள்",
  "innate_talents_abilities": "உட்பூர்வ திறமைகள் & திறன்கள்",
  "personal_growth_guidance": "தன்வளர்ச்சி வழிகாட்டுதல்",

  // Actions & Buttons
  "pay_and_generate_analysis": "என் குணநிலை பகுப்பாய்வை பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "பகுப்பாய்வு உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "nature_analysis_processing": "உங்கள் குணநிலை பகுப்பாய்வை எங்கள் நிபுணர் தன்மை பகுப்பாய்வாளர்கள் தயாரித்து வருகின்றனர். உங்கள் இயற்கை தன்மை மற்றும் நடத்தை முறைபாடுகள் குறித்த விரிவான நுண்ணறிவுகள் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_8_hours_delivery_note": "உங்கள் விரிவான குணநிலை அறிக்கை 8 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் குணநிலை பகுப்பாய்வு தொகுப்பு",
  "detailed_nature_report": "முழுமையான குணநிலை அறிக்கை (PDF)",
  "personality_traits_breakdown": "தன்மை பண்புகள் — விரிவாக",
  "behavioral_insights_guide": "நடத்தை நுண்ணறிவு வழிகாட்டி",
  "natural_abilities_assessment": "இயற்கை திறன்கள் மதிப்பீடு",
  "personal_development_roadmap": "தன்வளர்ச்சி சாலைவரைபடம்",

  // Visual Content
  "sample_nature_analysis": "மாதிரி குணநிலை பகுப்பாய்வு",
  "dominant_nature_type": "ஆதிக்கம் செலுத்தும் இயல்பு வகை",
  "sample_nature_reading": "சமநிலை பெற்ற பூமி-அக்னி இயல்பு மற்றும் வலுவான தலைமை பண்புகள்",
  "sample_nature_preview": "மூலக்கூறு நுண்ணறிவுகளுடன் உங்கள் தனிப்பயன் குணநிலை பகுப்பாய்வின் முன்னோட்டம்",
  "nature_elements": "இயற்கை மூலக்கூறுகள்",

  // Nature Element Types
  "fire": "அக்னி",
  "water": "ஆபு (நீர்)",
  "earth": "பூமி",
  "air": "வாயு",
  "ether": "ஆகாசம்",
  "nature": "இயல்பு",

  // Status & Processing
  "your_nature_analysis_status": "உங்கள் குணநிலை பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் இயற்கை தன்மை ஆய்வு செய்யப்படுகிறது",
  "analysis_processing_message": "உங்கள் பிறப்பு முறைபாடுகளை ஆய்ந்து, உங்கள் உண்மையான இயல்பும் நடத்தைப் போக்கும் நிர்ணயிக்கப்படுகின்றன.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_8_hours": "அறிக்கை 8 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "குணநிலை ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // Nature-Specific Elements
  "elemental_composition": "மூலக்கூறு கலவை",
  "dominant_element": "ஆதிக்க மூலக்கூறு",
  "secondary_elements": "இரண்டாம் நிலை மூலக்கூறுகள்",
  "elemental_balance": "மூலக்கூறு சமநிலை",
  "natural_constitution": "இயற்கை உடலமைப்பு/உள்ளமை",
  "temperament_type": "மனோபாவ வகை",

  // Personality Traits
  "core_personality_traits": "மைய தன்மை பண்புகள்",
  "surface_personality": "மேற்பரப்பு தன்மை",
  "hidden_personality": "மறைந்து உள்ள தன்மை",
  "authentic_self": "உண்மையான சுயம்",
  "personality_layers": "தன்மை அடுக்குகள்",
  "character_essence": "குணநலனின் சாரம்",

  // Behavioral Patterns
  "natural_reactions": "இயற்கை பிரதிசெயல்கள்",
  "instinctive_responses": "உள்ளுணர்வு பிரதியினைகள்",
  "behavioral_tendencies": "நடத்தைப் பரவாயங்கள்",
  "habitual_patterns": "வழக்கமான முறைபாடுகள்",
  "unconscious_behaviors": "அவச்சநிலை நடத்தை",
  "automatic_responses": "தானியக்க பிரதியினைகள்",

  // Strengths & Abilities
  "natural_strengths": "இயற்கை வலிமைகள்",
  "inherent_abilities": "உட்பொருந்திய திறன்கள்",
  "inborn_talents": "உட்பிறந்த திறமைகள்",
  "natural_gifts": "இயற்கை வரங்கள்",
  "core_competencies": "மைய திறன்கள்",
  "instinctive_skills": "உள்ளுணர்வு திறன்கள்",

  // Weaknesses & Challenges
  "natural_weaknesses": "இயற்கை பலவீனங்கள்",
  "blind_spots": "தன்மை குருட்டுப் புள்ளிகள்",
  "growth_areas": "வளர்ச்சி தேவையான பகுதிகள்",
  "challenging_traits": "சவாலான பண்புகள்",
  "limiting_patterns": "வரம்புப்படுத்தும் முறைபாடுகள்",
  "shadow_aspects": "நிழல் அம்சங்கள்",

  // Temperament Types
  "sanguine_nature": "சாங்குவீன் (Sanguine) இயல்பு",
  "choleric_nature": "கோலரிக் (Choleric) இயல்பு",
  "melancholic_nature": "மெலங்காலிக்க் (Melancholic) இயல்பு",
  "phlegmatic_nature": "ப்ளெக்மாட்டிக் (Phlegmatic) இயல்பு",
  "mixed_temperament": "கலப்பு மனோபாவம்",
  "temperament_blend": "மனோபாவ கலவை",

  // Elemental Natures
  "fire_personality": "அக்னி தன்மை",
  "water_personality": "நீர் தன்மை",
  "earth_personality": "பூமி தன்மை",
  "air_personality": "வாயு தன்மை",
  "space_personality": "ஆகாச தன்மை",
  "elemental_dominance": "மூலக்கூறு ஆதிக்கம்",

  // Interaction Styles
  "social_nature": "சமூக இயல்பு",
  "communication_style": "தொடர்பாடல் பாணி",
  "interaction_preferences": "ஊடாடும் விருப்பங்கள்",
  "relationship_approach": "உறவு அணுகுமுறை",
  "conflict_style": "மோதல் தீர்க்கும் பாணி",
  "leadership_nature": "தலைமை இயல்பு",

  // Emotional Nature
  "emotional_patterns": "உணர்ச்சி முறைபாடுகள்",
  "feeling_responses": "உணர்வு பிரதியினைகள்",
  "emotional_expression": "உணர்ச்சி வெளிப்பாடு",
  "mood_tendencies": "மனநிலை பரவாயங்கள்",
  "emotional_intelligence": "உணர்ச்சி நுண்ணறிவு",
  "sensitivity_levels": "உணர்திறன் நிலைகள்",

  // Mental Nature
  "thinking_patterns": "சிந்தனை முறைபாடுகள்",
  "mental_approach": "மன அணுகுமுறை",
  "cognitive_style": "அறிவு செயல்முறை பாணி",
  "learning_style": "கற்றல் பாணி",
  "decision_making": "முடிவு எடுக்கும் பாணி",
  "problem_solving": "சிக்கல் தீர்க்கும் அணுகுமுறை",

  // Physical Nature
  "physical_constitution": "உடல் அமைப்பு",
  "energy_patterns": "ஆற்றல் முறைபாடுகள்",
  "activity_preferences": "செயற்பாடு விருப்பங்கள்",
  "physical_expressions": "உடல் வெளிப்பாடுகள்",
  "body_language": "இயற்கை உடல் மொழி",
  "physical_tendencies": "உடல் சார்ந்த பரவாயங்கள்",

  // Spiritual Nature
  "spiritual_inclinations": "ஆன்மீக விருப்பங்கள்",
  "inner_nature": "உள்ளார்ந்த இயல்பு",
  "soul_expression": "ஆத்தும வெளிப்பாடு",
  "spiritual_path": "இயற்கை ஆன்மீகப் பாதை",
  "divine_connection": "தெய்வீக இணைப்பு பாணி",
  "transcendental_nature": "அதிகமன நிலை இயல்பு",

  // Life Approach
  "life_philosophy": "இயற்கை வாழ்க்கை தத்துவம்",
  "approach_to_challenges": "சவால்களை அணுகும் பாணி",
  "goal_orientation": "இலக்கு நோக்கம்",
  "success_definition": "வெற்றியின் வரையறை",
  "life_priorities": "வாழ்க்கை முன்னுரிமைகள்",
  "value_system": "மைய மதிப்புக் கோட்பாடு",

  // Career Nature
  "work_style": "இயற்கை வேலை பாணி",
  "career_preferences": "தொழில் விருப்பங்கள்",
  "professional_nature": "தொழில்முறை இயல்பு",
  "workplace_behavior": "பணியிடம் நடத்தை",
  "team_dynamics": "குழு இயக்கவியல்",
  "professional_growth": "தொழில்முறை வளர்ச்சி முறை",

  // Relationship Nature
  "relationship_style": "உறவு பாணி",
  "love_expression": "காதல் வெளிப்பாடு",
  "friendship_patterns": "நட்பு முறைபாடுகள்",
  "family_dynamics": "குடும்ப இயக்கவியல்",
  "partnership_nature": "கூட்டாண்மை இயல்பு",
  "social_connections": "சமூக இணைப்புகள்",

  // Growth & Development
  "natural_evolution": "இயற்கை பரிணாமப் பாதை",
  "growth_potential": "வளர்ச்சி திறன்",
  "development_areas": "வளர்ச்சி பகுதிகள்",
  "transformation_capacity": "மாற்றுத் திறன்",
  "learning_opportunities": "கற்றல் வாய்ப்புகள்",
  "self_improvement": "சுய மேம்பாட்டு பகுதிகள்",

  // Seasonal Nature
  "seasonal_influences": "஋து தாக்கங்கள்",
  "cyclical_patterns": "சுழற்சி முறைபாடுகள்",
  "natural_rhythms": "இயற்கை தாளங்கள்",
  "biorhythms": "தனிப்பட்ட வாழ்க்கைத் தாளங்கள்",
  "energy_cycles": "ஆற்றல் சுழற்சிகள்",
  "mood_cycles": "மனநிலை சுழற்சிகள்",

  // Environmental Nature
  "environmental_preferences": "சுற்றுப்புற விருப்பங்கள்",
  "natural_habitat": "இயற்கை வதிவிடம்",
  "climate_preferences": "காலநிலை விருப்பங்கள்",
  "space_requirements": "இடத் தேவைகள்",
  "comfort_zones": "உற்சாக பகுதிகள்",
  "optimal_environments": "சிறந்த சூழல்கள்",

  // Communication Nature
  "expression_style": "வெளிப்பாட்டு பாணி",
  "listening_style": "கேட்பு பாணி",
  "verbal_patterns": "வாக்கு முறைபாடுகள்",
  "non_verbal_communication": "மொழியற்ற தொடர்பாடல்",
  "communication_barriers": "தொடர்பாடல் தடைகள்",
  "effective_communication": "சரியான தொடர்பாடல் குறிப்புகள்",

  // Stress & Relaxation
  "stress_patterns": "மனஅழுத்த முறைபாடுகள்",
  "stress_responses": "மனஅழுத்தப் பிரதியினைகள்",
  "relaxation_needs": "ஓய்வு தேவைகள்",
  "recovery_methods": "மீட்பு முறைகள்",
  "self_care_nature": "சுய பராமரிப்பு இயல்பு",
  "wellness_approaches": "நலன் அணுகுமுறைகள்",

  // Creative Nature
  "creative_expression": "படைப்புத் திறன் வெளிப்பாடு",
  "artistic_inclinations": "கலை விருப்பங்கள்",
  "innovation_style": "புதுமை பாணி",
  "creative_processes": "படைப்புச் செயல்முறைகள்",
  "inspiration_sources": "ஈர்ப்பு ஆதாரங்கள்",
  "creative_blocks": "படைப்பு தடை & தீர்வுகள்"
};
